<div class="container tab-login">
  <a [routerLink]="{ cxRoute: 'register' } | cxUrl" [class]="login ? 'active' : ''"> {{ 'loginForm.register' | cxTranslate }}</a>
  <a [routerLink]="{ cxRoute: 'login' } | cxUrl" [class]="!login ? 'active' : ''"> {{ 'loginForm.accessTitle' | cxTranslate }}</a>
</div>
